import { Ml_Log_Status } from "@generated/graphql";
import { CheckOutlined, ErrorOutline } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { ML_LOG_STATUS_TITLE } from "constants/global";
import CircularLoading from "./CircularLoading";

interface QuestionsGeneratingLogStatusProps {
  status: Ml_Log_Status;
}

const QuestionsGeneratingLogStatus = ({ status }: QuestionsGeneratingLogStatusProps) => {
  let res;

  if (status === Ml_Log_Status.Initialized)
    res = (
      // span - для корректного отображения тултипа
      <span>
        <CircularLoading
          size={18}
          sx={{ py: 0, justifyContent: "flex-start" }}
        />
      </span>
    );
  else if (status === Ml_Log_Status.Success) res = <CheckOutlined color='success' />;
  else res = <ErrorOutline color='error' />;

  return <Tooltip title={ML_LOG_STATUS_TITLE[status]}>{res}</Tooltip>;
};

export default QuestionsGeneratingLogStatus;
